module.exports = __webpack_public_path__ + "img/qy.fa7c9c96.png";